
<!-- content -->
<section class="row">
  <div class="container">
    <div class="col s12">
      <h1>Unsubscribe</h1>

      @if (status=='IN_PROGRESS') {
        <p>
          Please wait while we unsubscribe you.
          @if (isBrowser) {
            <mat-progress-spinner mode="indeterminate" color="secondary">
            </mat-progress-spinner>
          }
        </p>
      }

      @if (status=='DONE') {
        <p>
          You have been successfully unsubscribed from the {{listName}}.
        </p>
      }
      @if (error?.ErrorCode == 'SUBSCRIPTIONS_EMAIL_NOT_FOUND') {
        <p>
          The supplied email is not currently registered for {{listName}}. <b>No action was taken.</b>
        </p>
      }
      @if (error?.ErrorCode == 'SUBSCRIPTIONS_UNKNOWN_ERROR') {
        <p>
          There was an error un-subscribing from the {{listName}}.
          Error Details: <b>{{ error?.Message }}.</b>
        </p>
      }
      <p>
        Sincerely
      </p>
      <p>
        Matboard and More
      </p>
    </div>
  </div>
</section>
<!-- // content -->
